export const ENTITY_GROUP_DELETE = `
    mutation M ( $id: Long )
    {
        entity_group_delete ( input: { id: $id } )                     
        {
          id
          status
        }    
  }
`;